import { style } from '@vanilla-extract/css';

export const tableHeader = style({
  width: 'var(--cell-width)',
  backgroundColor: 'var(--wt-table-header-background-color)',
  borderStyle: 'solid',
  borderColor: 'var(--wt-table-border-color)',
  borderTopWidth: 'var(--wt-table-border-top-width, var(--wt-table-border-width))',
  borderRightWidth: 'var(--wt-table-border-right-width, var(--wt-table-border-width))',
  borderBottomWidth: 'var(--wt-table-border-bottom-width, var(--wt-table-border-width))',
  borderLeftWidth: 'var(--wt-table-border-left-width, var(--wt-table-border-width))',
  paddingTop: 'var(--wt-table-header-padding-top, var(--wt-table-header-padding))',
  paddingBottom: 'var(--wt-table-header-padding-bottom, var(--wt-table-header-padding))',
  paddingLeft: 'var(--wt-table-header-padding-left, var(--wt-table-header-padding))',
  paddingRight: 'var(--wt-table-header-padding-right, var(--wt-table-header-padding))',
  color: 'var(--wt-table-header-font-color)',
});
